/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';
import { SumsubTokenResponse, TravelRuleStatusResponse, VigilanceDeadlineResponse, VigilanceStatusResponse } from '@/types/sumsub';

export class SumsubService {
  private static readonly SUMSUB_TOKEN_ENDPOINT = '/app/sumsub/token';
  private static readonly SUMSUB_VIGILANCE_TOKEN_ENDPOINT = '/app/sumsub/token/vigilance';
  private static readonly SUMSUB_MANDATE_TOKEN_ENDPOINT = '/app/sumsub/token/mandate';
  private static readonly SUMSUB_TRAVEL_RULE_TOKEN_ENDPOINT = '/app/sumsub/token/travel-rule';
  private static readonly VIGILANCE_DEADLINE_ENDPOINT = '/app/users/vigilance/deadline';
  private static readonly VIGILANCE_STATUS_ENDPOINT = '/app/users/vigilance/status';
  private static readonly TRAVEL_RULE_STATUS_ENDPOINT = '/app/users/travel-rule/status';

  public static async getToken(): Promise<SumsubTokenResponse> {
    const res: AxiosResponse<SumsubTokenResponse> = await axiosInstance.get(SumsubService.SUMSUB_TOKEN_ENDPOINT)
    return res.data
  }

  public static async getVigilanceToken(): Promise<SumsubTokenResponse> {
    const res: AxiosResponse<SumsubTokenResponse> = await axiosInstance.get(SumsubService.SUMSUB_VIGILANCE_TOKEN_ENDPOINT)
    return res.data
  }

  public static async getVigilanceDeadline(): Promise<VigilanceDeadlineResponse> {
    const res: AxiosResponse<VigilanceDeadlineResponse> = await axiosInstance.get(SumsubService.VIGILANCE_DEADLINE_ENDPOINT)
    return res.data
  }

  public static async getVigilanceStatus(): Promise<VigilanceStatusResponse> {
    const res: AxiosResponse<VigilanceStatusResponse> = await axiosInstance.get(SumsubService.VIGILANCE_STATUS_ENDPOINT)
    return res.data
  }

  public static async getTravelRuleStatus(): Promise<TravelRuleStatusResponse> {
    const res: AxiosResponse<TravelRuleStatusResponse> = await axiosInstance.get(SumsubService.TRAVEL_RULE_STATUS_ENDPOINT)
    return res.data
  }

  public static async getTravelRuleToken(type: 'deposit' | 'withdrawal'): Promise<SumsubTokenResponse> {
    const res: AxiosResponse<SumsubTokenResponse> = await axiosInstance.get(`${SumsubService.SUMSUB_TRAVEL_RULE_TOKEN_ENDPOINT}/${type}`)
    return res.data
  }

  public static async getMandateToken(): Promise<SumsubTokenResponse> {
    const res: AxiosResponse<SumsubTokenResponse> = await axiosInstance.get(SumsubService.SUMSUB_MANDATE_TOKEN_ENDPOINT);
    return res.data;
  }
}
